import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PageInFlowNoSidebarLayout, {
  PageInFlowNoSidebarLayoutProps,
} from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import EmployeeFlowDelegate from 'store/flows/subscriber/employeeFlowDelegate';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';

interface EmployeeFlowLayoutProps extends Omit<PageInFlowNoSidebarLayoutProps, 'domainParams' | 'moreInfoBlob'> {
  flowDelegate: EmployeeFlowDelegate;
  pageId: SubscriberRouteV2Id;
  isInitialLoading?: boolean;
}

const EmployeeFlowLayout: React.FC<EmployeeFlowLayoutProps> = observer(
  ({ flowDelegate, pageId, isInitialLoading, ...rest }) => {
    const { groupId } = flowDelegate.domainData;

    useEffect(() => {
      void flowDelegate.getFlowInitialData();
    }, [flowDelegate, groupId]);

    const moreInfoBlob = flowDelegate.groupInfoDelegate.moreInfoBlobInput
      ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
      : undefined;

    return (
      <PageInFlowNoSidebarLayout
        {...rest}
        domainParams={{ ...flowDelegate.domainData }}
        pageId={pageId}
        isInitialLoading={isInitialLoading}
        isInfoSectionLoading={flowDelegate.isFlowDataLoading}
        isActionLoading={flowDelegate.isActionLoading}
        moreInfoBlob={moreInfoBlob}
      />
    );
  },
);

export default EmployeeFlowLayout;
